// extracted by mini-css-extract-plugin
export default {"uplifts":"Uplifts_uplifts__xzI6v","uplifts__title":"Uplifts_uplifts__title__mXSB0","uplifts__img":"Uplifts_uplifts__img__fLfVe"};